import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY, PnvPznType, Pnv2PznType } from '../constants';
import { apiProvider } from '../api';
import { types } from './types';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		PnvPzn: [],
		Pnv2Pzn: [],
	},
	filter: {
		VyrazenPrp: null as boolean | null,
		ObchPripadId: null as number | null,
		Otevrene: null as boolean | null,
		Uvolnene: null as boolean | null,
		Uzavrene: null as boolean | null,
		Predani: null as boolean | null,
		ProvozovnaId: null as number | null,
		KomiseNr: null as string | null,
		PnvNr: null as number | null,
		Vin: null as string | null,
		ZakaznikId: null as number | null,
		ZakaznikIdText: null as string | null,
		PnvPzn: null as PnvPznType | null,
		Pnv2Pzn: null as Pnv2PznType | null,
		PredpoklDatOd: null as string | null,
		PredpoklDatDo: null as string | null,
		ProdejceprId: null as number | null,
		ProdejceprIdText: null as string | null,
		ProdejceprOsobniCis: null as string | null,
		VstupDatOd: null as string | null,
		VstupDatDo: null as string | null,
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[types.mutations.PNV_ZAKAZNIK_LIST_MAPPER](state, { data }) {
			state.filter.ZakaznikId = data.value;
			state.filter.ZakaznikIdText = data.text;
		},
		[types.mutations.PNV_PRACOVNIK_LIST_MAPPER](state, { data }) {
			state.filter.ProdejceprId = data.value;
			state.filter.ProdejceprIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.filter.ProdejceprOsobniCis = data.osobniCis;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
